import React from 'react'
import Icon from '@jarvis.oddle/core/decorators/Icon'
import { IconInterface } from './IconInterface'

const IconDeliveringOrder = ({
  className,
  height,
  width,
  fill
}: IconInterface) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 32 33'
      className={className}
      fill={fill || 'none'}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M16 30.2143C8.43771 30.2143 2.28571 24.0623 2.28571 16.5C2.28571 8.93771 8.43771 2.78571 16 2.78571C23.5623 2.78571 29.7143 8.93771 29.7143 16.5C29.7143 24.0623 23.5623 30.2143 16 30.2143ZM16 0.5C7.17714 0.5 0 7.67714 0 16.5C0 25.3229 7.17714 32.5 16 32.5C24.8229 32.5 32 25.3229 32 16.5C32 7.67714 24.8229 0.5 16 0.5ZM22.3293 11.1283L13.7247 19.7238L9.74183 15.6438C9.30069 15.1923 8.57726 15.1855 8.12583 15.6243C7.6744 16.0643 7.66526 16.7889 8.1064 17.2403L12.8961 22.1466C13.1098 22.3649 13.4013 22.4883 13.7075 22.4906H13.7144C14.0173 22.4906 14.3075 22.3706 14.5224 22.1569L23.9453 12.7466C24.3921 12.2998 24.3921 11.5775 23.9464 11.1295C23.4995 10.6826 22.7761 10.6838 22.3293 11.1283Z'
        fill={fill}
      />
    </svg>
  )
}

export default Icon(IconDeliveringOrder)
